export type NavIconKind =
  | "grid"
  | "stack"
  | "compass"
  | "users"
  | "doc"
  | "gear";

interface Props {
  kind: NavIconKind;
}

const COMMON = {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function NavIcon({ kind }: Props) {
  switch (kind) {
    case "grid":
      return (
        <svg {...COMMON}>
          <rect x="2" y="2" width="5" height="5" />
          <rect x="9" y="2" width="5" height="5" />
          <rect x="2" y="9" width="5" height="5" />
          <rect x="9" y="9" width="5" height="5" />
        </svg>
      );
    case "stack":
      return (
        <svg {...COMMON}>
          <path d="M2 4l6-2.5L14 4l-6 2.5L2 4z" />
          <path d="M2 8l6 2.5L14 8" />
          <path d="M2 12l6 2.5L14 12" />
        </svg>
      );
    case "compass":
      return (
        <svg {...COMMON}>
          <circle cx="8" cy="8" r="6" />
          <path d="M10.5 5.5L9 9l-3.5 1.5L7 7l3.5-1.5z" />
        </svg>
      );
    case "users":
      return (
        <svg {...COMMON}>
          <circle cx="6" cy="6" r="2.5" />
          <path d="M2 13c0-2.2 1.8-4 4-4s4 1.8 4 4" />
          <circle cx="11" cy="5" r="2" />
          <path d="M9.5 9.5c2 0 4 1.4 4 3.5" />
        </svg>
      );
    case "doc":
      return (
        <svg {...COMMON}>
          <path d="M4 2h5l3 3v9H4z" />
          <path d="M9 2v3h3" />
          <path d="M6 8h4M6 11h4" />
        </svg>
      );
    case "gear":
      return (
        <svg {...COMMON}>
          <circle cx="8" cy="8" r="2" />
          <path d="M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.5 3.5l1.4 1.4M11.1 11.1l1.4 1.4M3.5 12.5l1.4-1.4M11.1 4.9l1.4-1.4" />
        </svg>
      );
    default:
      return null;
  }
}
